import { useState, useEffect } from 'react';
import { useAuth } from '../state/AuthContext';
import InventoryApiService from '../services/InventoryApiService';
import APIConstants from '../services/APIConstants';
import DebugService from '../services/DebugService';
import { ADD_NEW_ACCOUNT } from '../components/common/Helper';

const useTagList = (type) => {
  const { selectedAccount } = useAuth();
  const [tagList, setTagList] = useState([]);

  useEffect(() => {
    if (!selectedAccount || selectedAccount === ADD_NEW_ACCOUNT) {
      setTagList([]);
      return;
    }
    const dataRequest = { type, userAccountId: selectedAccount };
    InventoryApiService.getFilterTagList(APIConstants.ENDPOINT_AWS_FILTER_TAG, dataRequest)
      .then((res) => {
        setTagList(res?.data ?? []);
      })
      .catch((err) => {
        DebugService.error('useTagList: Error fetching tag list', err);
        setTagList([]);
      });
  }, [selectedAccount]);

  return { tagList };
};

export default useTagList;
